import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import { CreateTalentJob } from "../../../../../types/createJobSchema";
import { useGetCountriesWithCoordinates } from "../../../../../../../api/v1/queries/useGetCountriesWithCoordinates";

import {
  JobEndDateIcon,
  JobModeIcon,
  LocationIcon,
  PlayerPositionIcon,
  SalaryIcon,
} from "../../../../../assets/icons/go-hire-page-icons";

const PlayerInfo = ({ jobDetails }: { jobDetails: CreateTalentJob }) => {
  const { t } = useTranslation("goHire", { keyPrefix: "createJobPage.previewAndPublishJob" });
  const { t: tHireEnums } = useTranslation("goHire", { keyPrefix: "enum" });
  const { t: tPosition } = useTranslation("common", { keyPrefix: "user.playerPosition" });

  const { countriesWithCoordinates } = useGetCountriesWithCoordinates();

  const countryNames = jobDetails.jobLocation
    .map((id) => countriesWithCoordinates?.find((c: any) => c.id === id)?.name)
    .filter(Boolean)
    .join(", ");

  const playerInfoList = [
    {
      icon: <PlayerPositionIcon />,
      title: `${tPosition(jobDetails.primaryPosition)} , ${tPosition(jobDetails.secondaryPosition)}`,
    },
    {
      icon: <JobModeIcon />,
      title: tHireEnums(`jobMode.${jobDetails.jobMode}`),
    },
    {
      icon: <LocationIcon />,
      title: countryNames || t("noLocationSpecified"), // Fallback if no names found
    },
    {
      icon: <SalaryIcon />,
      title: `${jobDetails.salaryAmount / 100} ${jobDetails.salaryCurrency} per ${tHireEnums(
        `salaryPer.${jobDetails.salaryPer}`
      )}`,
    },
    {
      icon: <JobEndDateIcon />,
      title: `End in ${format(new Date(jobDetails.applyEnds), "dd MMM yyyy")}`,
    },
  ];

  return (
    <Box component="section" sx={styles.container}>
      <Typography sx={styles.title}>{t("professionalFootballPlayer")}</Typography>
      <Box sx={styles.listContainer}>
        {playerInfoList.map(({ icon, title }) => (
          <Box sx={styles.listItem}>
            {icon}
            <Typography sx={styles.listItemTitle}>{title}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default PlayerInfo;

const styles = {
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  listContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  title: {
    fontFamily: "Montserrat",
    color: "var(--Dark---1000, #111)",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
  },
  listItemTitle: {
    fontFamily: "Montserrat",
    color: "var(--Dark-Mode---100, #1E2021)",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "24px",
  },
};
